<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-col cols="12" sm="12">
            <v-card class="box">
                <v-col cols="12" sm="12">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Course Scheme Applied Status
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-row justify="center" class="p-0 m-0">
                        <v-col class="p-0 m-0" cols="12" sm="4" md="4">
                            <v-autocomplete
                                class="pt-2"
                                dense
                                required
                                outlined
                                rounded
                                color="#0F2027"
                                v-model="ay"
                                :items="ay_list"
                                item-text="ay"
                                item-value="id"
                                label="Academic Year"
                                persistent-hint
                                hint="Please select Academic Year"
                            />
                        </v-col>
                        <v-col class="p-0 m-0" cols="12" sm="4" md="4">
                            <v-autocomplete class="pt-2" dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list" item-text="name" item-value="id" label="Semester" persistent-hint hint="Please select semester" />
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center" class="p-0 m-0">
                        <v-btn dense outlined rounded :loading="loader" class="button" @click="get_all_data()">Proceed</v-btn>
                    </v-row>
                </v-col>
            </v-card>
            <v-card class="box" v-if="crs_list!= '' ">
            <v-data-table v-if="crs_list.length > 0" dense :headers="headers1" :items="bookList1" :search="search" class="elevation-1 mytable" @current-items="getFiltered">
                <template v-slot:top class="pb-5">
                    <v-row justify="center" align="center">
                        <tr class="t-row">
                            <div>
                                <th>
                                <v-col cols="12" sm="12" md="12">
                                    <v-row>
                                    <download-excel  class="mr-2 pb-3 pt-2"
                                            :data   = "bookList1"
                                            :fields = "table_fields"
                                            worksheet = "Scheme_Applied_status"
                                            name    = "Scheme_Applied_status.xls">
                                            <v-btn  color="success" outlined rounded > <v-icon dark>mdi-file-excel</v-icon> Export  </v-btn>
                                        </download-excel>
                                        <span v-for="header in headers1" :key="header.text">
                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                <v-autocomplete
                                                    class="mr-2 pb-5 pt-2"
                                                    flat
                                                    hide-details
                                                    small
                                                    rounded
                                                    dense
                                                    outlined
                                                    color="#0F2027"
                                                    :label="header.text"
                                                    multiple
                                                    clearable
                                                    :items="columnValueList(header.value)"
                                                    v-model="filters[header.value]"
                                                ></v-autocomplete>
                                            </span>
                                        </span>
                                    </v-row>
                                     </v-col>
                                </th>
                            </div>
                        </tr>
                    </v-row>
                </template>
            </v-data-table>
        </v-card>
        </v-col>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                snackbar_msg: null,
                snackbar: false,
                loader: false,
                color: "",
                ay_list: [],
                ay: null,
                search: null,
                crs_list: [],
                filterArr: [],
                filters: {
                    crs_name: [],
                    standard: [],
                    coursemarksentrytype: [],
                    coursetype: [],
                    courseassessmentscheme: [],
                    gradingscheme: [],
                },
                 table_fields: {
                    'Sr. No':'srno',
                    'Course':'crs_name',
                    'Academic Year':'academicyear',
                    'Semester':'semester',
                    'Standard':'standard',
                    'Mark Entry Type':'coursemarksentrytype',
                    'Course Type':'coursetype',
                    'Assessment Scheme':'courseassessmentscheme',
                    'Grading Scheme':'gradingscheme',
                },
                 headers1: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Course",
                        align: "center",
                        sortable: false,
                        value: "crs_name",
                    },
                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "academicyear",
                    },
                     {
                        text: "Semester",
                        align: "center",
                        sortable: false,
                        value: "semester",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "standard",
                    },
                     {
                        text: "Mark Entry Type",
                        align: "center",
                        sortable: false,
                        value: "coursemarksentrytype",
                    },
                    {
                        text: "Course Type",
                        align: "center",
                        sortable: false,
                        value: "coursetype",
                    },
                    {
                        text: "Assessment Scheme",
                        align: "center",
                        sortable: false,
                        value: "courseassessmentscheme",
                    },
                    {
                        text: "Grading Scheme",
                        align: "center",
                        sortable: false,
                        value: "gradingscheme",
                    },
                    
                ],
            };
        },
         computed: {
            bookList1() {
                return this.crs_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        mounted() {
            this.onload();
        },
        methods: {
             getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.crs_list.map((d) => d[val]);
            },
            onload() {
                axios
                    .post("/examination/applySchemeHome")
                    .then((res) => {
                        this.ay_list = res.data.academic_year_list;
                        this.semester_list = res.data.semester_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
            get_all_data(){
                 const formData = {
                    ay:this.ay,
                    sem:this.sem
                }
                this.loader = true;
                axios
                    .post("/Examination/scheme_applied_status", formData)
                    .then((res) => {
                        this.crs_list = res.data.course_list;
                        this.loader = false;
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.loader = false;
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
